/* eslint-disable no-unused-expressions */
/* eslint-disable import/prefer-default-export */
import React, { createContext, useContext, useEffect, useState } from 'react';
import { ValesData } from '../../../types/Types';
import { FiltersConstants } from '../../../utils/FiltersConstants';

export type ValeContextType = {
  isOpenFilter: boolean;
  activeFilters: string[];
  hideLsNoActivados: ValesData[]; // vales ocultos todos
  hideLsFiltradaNoActivados: ValesData[];
  hideLsPreactiva2: ValesData[];
  hideLsActivados: ValesData[];
  hideLsFiltradaActivados: ValesData[];
  hideLsCanjeados: ValesData[];
  hideLsFiltradaCanjeados: ValesData[];
  filtrosProductos: string[];
  showMoreNoAct: boolean;
  showMoreAct: boolean;
  showMoreCanj: boolean;
  filtrosOtros: string[];
  filtrosOtrosAMostrar: string[];
  isFiltroSoportePostalVisible: boolean;
  filtrosOtrosActivos: string[];
  voucherNotActWithFilterApplied: ValesData[];
  voucherActWithFilterApplied: ValesData[];
  voucherCanjWithFilterApplied: ValesData[];
  voucherPromoWithFilterApplied: ValesData[];
  changeOpenFilter: () => void;
  existenFiltrosvisibles: () => boolean;
  loadFilterProducs: (listFilterProduct: string[]) => void;
  loadFilterOtros: (listFilterOther: string[]) => void;
  loadFiltrosOtrosAMostrar: (lsFiltroOtrosAMostrar: string[]) => void;
  loadIsFiltrosSoportePostalVisible: (isVisible: boolean) => void;
  addFilter: (filter: string) => void;
  addFilterURL: (filter: string) => void;
  loadFilters: (filters: string[]) => void;
  loadFiltersOtros: (filtersURL: string[]) => void;
  changeShowMoreNoAct: (state: boolean) => void;
  changeShowMoreAct: (state: boolean) => void;
  changeShowMoreCanj: (state: boolean) => void;
  changeHideLsNoActivados: () => void; // TODO: eliminable
  loadHideLsNoActivados: (valesData: ValesData[]) => void;
  loadHideLsFiltradaNoActivados: (valesData: ValesData[]) => void;
  loadHideLsPreactiva2: (valesData: ValesData[]) => void;
  loadHideLsActivados: (valesData: ValesData[]) => void;
  loadHideLsCanjeados: (valesData: ValesData[]) => void;

  filtrarTodosLosCupones: (
    valesSFNoActiv: ValesData[],
    valesSFActiv: ValesData[],
    valesSFCanj: ValesData[],
    valesSFPro: ValesData[],
  ) => void;
  loadValesVisiblesNoFiltrados: (
    valesNoAct: ValesData[],
    valesAct: ValesData[],
    valesCanj: ValesData[],
    valesPro: ValesData[],
  ) => void;
  valesVisiblesSFNoActivados: ValesData[];
  valesVisiblesSFActivados: ValesData[];
  valesVisiblesSFCanjeados: ValesData[];
  valesVisiblesSFPromos: ValesData[];
};
export const defaultContextValue = {
  isOpenFilter: false,
  filtrosOtros: [],
  filtrosOtrosAMostrar: [],
  isFiltroSoportePostalVisible: false,
  filtrosProductos: [],
  hideLsNoActivados: [],
  hideLsFiltradaNoActivados: [],
  hideLsPreactiva2: [],
  hideLsActivados: [],
  hideLsFiltradaActivados: [],
  hideLsCanjeados: [],
  hideLsFiltradaCanjeados: [],
  filters: [],
  filtrosOtrosActivos: [],
  voucherNotActWithFilterApplied: [],
  voucherActWithFilterApplied: [],
  voucherCanjWithFilterApplied: [],
  voucherPromoWithFilterApplied: [],
  voucherShowList: [],
  voucherHideList: [],
  valesVisiblesSFNoActivados: [],
  valesVisiblesSFActivados: [],
  valesVisiblesSFCanjeados: [],
  valesVisiblesSFPromos: [],
  showMoreNoAct: false,
  showMoreAct: false,
  showMoreCanj: false,
};
export const ValeContext = createContext<ValeContextType>(
  (defaultContextValue as unknown) as ValeContextType,
);

export const ValeProvider = ({ children }) => {
  const [showMoreNoAct, setShowMoreNoAct] = useState(
    defaultContextValue.showMoreNoAct,
  );
  const [showMoreAct, setShowMoreAct] = useState(
    defaultContextValue.showMoreAct,
  );
  const [showMoreCanj, setShowMoreCanj] = useState(
    defaultContextValue.showMoreCanj,
  );
  const [isOpenFilter, setIsOpenFilter] = useState(
    defaultContextValue.isOpenFilter,
  );
  const [hideLsNoActivados, setHideLsNoActivados] = useState<ValesData[]>(
    defaultContextValue.hideLsNoActivados,
  );
  const [hideLsFiltradaNoActivados, setHideLsFiltradaNoActivados] = useState<
    ValesData[]
  >(defaultContextValue.hideLsFiltradaNoActivados);
  const [hideLsPreactiva2, setHideLsPreactiva2] = useState<ValesData[]>(
    defaultContextValue.hideLsPreactiva2,
  );
  const [hideLsActivados, setHideLsActivados] = useState<ValesData[]>(
    defaultContextValue.hideLsActivados,
  );
  const [hideLsFiltradaActivados, setHideLsFiltradaActivados] = useState<
    ValesData[]
  >(defaultContextValue.hideLsFiltradaActivados);
  const [hideLsCanjeados, setHideLsCanjeados] = useState<ValesData[]>(
    defaultContextValue.hideLsCanjeados,
  );
  const [hideLsFiltradaCanjeados, setHideLsFiltradaCanjeados] = useState<
    ValesData[]
  >(defaultContextValue.hideLsFiltradaCanjeados);
  const [filtrosOtros, setFiltrosOtros] = useState<string[]>(
    defaultContextValue.filtrosOtros,
  );
  const [
    isFiltroSoportePostalVisible,
    setIsFiltroSoportePostalVisible,
  ] = useState<boolean>(defaultContextValue.isFiltroSoportePostalVisible);
  const [filtrosOtrosAMostrar, setFiltrosOtrosAMostrar] = useState<string[]>(
    defaultContextValue.filtrosOtrosAMostrar,
  );
  const [filtrosProductos, setFiltrosProductos] = useState<string[]>(
    defaultContextValue.filtrosProductos,
  );
  const [activeFilters, setActiveFilters] = useState<string[]>(
    defaultContextValue.filters,
  );
  const [filtrosOtrosActivos, setFiltrosOtrosActivos] = useState<string[]>(
    defaultContextValue.filtrosOtrosActivos,
  );
  const [valesVisiblesSFNoActivados, setValesVisiblesSFNoActivados] = useState<
    ValesData[]
  >(defaultContextValue.valesVisiblesSFNoActivados);
  const [valesVisiblesSFActivados, setValesVisiblesSFActivados] = useState<
    ValesData[]
  >(defaultContextValue.valesVisiblesSFActivados);
  const [valesVisiblesSFCanjeados, setValesVisiblesSFCanjeados] = useState<
    ValesData[]
  >(defaultContextValue.valesVisiblesSFCanjeados);
  const [valesVisiblesSFPromos, setValesVisiblesSFPromos] = useState<
    ValesData[]
  >(defaultContextValue.valesVisiblesSFPromos);
  const [
    voucherNotActWithFilterApplied,
    setVoucherNotActWithFilterApplied,
  ] = useState<ValesData[]>(defaultContextValue.voucherNotActWithFilterApplied);
  const [
    voucherActWithFilterApplied,
    setVoucherActWithFilterApplied,
  ] = useState<ValesData[]>(defaultContextValue.voucherActWithFilterApplied);
  const [
    voucherCanjWithFilterApplied,
    setVoucherCanjWithFilterApplied,
  ] = useState<ValesData[]>(defaultContextValue.voucherCanjWithFilterApplied);
  const [
    voucherPromoWithFilterApplied,
    setVoucherPromoWithFilterApplied,
  ] = useState<ValesData[]>(defaultContextValue.voucherPromoWithFilterApplied);

  function eliminarDuplicados(listaVales: ValesData[]) {
    let z = 0;
    while (z < listaVales.length) {
      let m = listaVales.length - 1;
      while (z < m && m < listaVales.length) {
        if (listaVales[z].valeEAN === listaVales[m].valeEAN) {
          listaVales.splice(m, 1);
        } else {
          m -= 1;
        }
      }
      z += 1;
    }
  }
  function isCuponVisiblefiltradoPorProductos(valeVisibeAFiltrar: ValesData) {
    let isCuponCoincidenteFiltroProductos = false;
    const { estructurasComerciales } = valeVisibeAFiltrar;
    for (let j = 0; j < estructurasComerciales.length; j += 1) {
      for (let k = 0; k < activeFilters.length; k += 1) {
        if (estructurasComerciales[j].seccion === activeFilters[k]) {
          isCuponCoincidenteFiltroProductos = true;
          k = activeFilters.length;
          j = estructurasComerciales.length;
        }
      }
    }
    return isCuponCoincidenteFiltroProductos;
  }

  function isCuponVisibleFiltradoOtros(valeVisibeAFiltrar: ValesData) {
    let isCuponCoincidentefiltroOtros = false;
    const {
      denominacionPlanAdhesion,
      denominacionSoportePostal,
    } = valeVisibeAFiltrar;
    for (let z = 0; z < filtrosOtrosActivos.length; z += 1) {
      if (
        filtrosOtrosActivos[z] === denominacionPlanAdhesion ||
        filtrosOtrosActivos[z] === denominacionSoportePostal
      ) {
        isCuponCoincidentefiltroOtros = true;
        z = filtrosOtrosActivos.length;
      }
    }
    return isCuponCoincidentefiltroOtros;
  }

  function getCuponesFiltrados(valesVisiblsAFiltrar: ValesData[]) {
    const cuponesFiltrados: ValesData[] = [];
    const listaFiltrada = valesVisiblsAFiltrar.filter(
      (elemento) => elemento !== undefined,
    );
    const isFiltroProductosActivo = activeFilters.length > 0;
    const isFiltroOtrosActivo = filtrosOtrosActivos.length > 0;
    const isFiltroCombinado = isFiltroProductosActivo && isFiltroOtrosActivo;
    for (let i = 0; i < listaFiltrada.length; i += 1) {
      const isCuponFiltradoOtros = isFiltroOtrosActivo
        ? isCuponVisibleFiltradoOtros(listaFiltrada[i])
        : false;
      const isCuponFiltradoProductos = isFiltroProductosActivo
        ? isCuponVisiblefiltradoPorProductos(listaFiltrada[i])
        : false;
      const isCuponFiltradoVisible =
        (isFiltroCombinado &&
          isCuponFiltradoProductos &&
          isCuponFiltradoOtros) ||
        (!isFiltroCombinado &&
          (isCuponFiltradoProductos || isCuponFiltradoOtros));
      if (isCuponFiltradoVisible) {
        cuponesFiltrados.push(listaFiltrada[i]);
      }
    }
    return cuponesFiltrados;
  }

  function filtrarCuponesNoActivados(allVisiblesSFNoAct: ValesData[]) {
    const valesFiltradosNoActivados = getCuponesFiltrados(allVisiblesSFNoAct);
    const nuevosOcultosFiltrados = getCuponesFiltrados(hideLsNoActivados);
    const numLimiteVisiblesNoAct = valesVisiblesSFNoActivados.length;
    while (
      nuevosOcultosFiltrados.length > 0 &&
      valesFiltradosNoActivados.length < numLimiteVisiblesNoAct
    ) {
      const cuponOcultoFiltradoAvisibleFiltrado = nuevosOcultosFiltrados.shift();
      if (cuponOcultoFiltradoAvisibleFiltrado !== undefined) {
        valesFiltradosNoActivados.push(cuponOcultoFiltradoAvisibleFiltrado);
      }
    }
    setVoucherNotActWithFilterApplied(valesFiltradosNoActivados);
    setHideLsFiltradaNoActivados(nuevosOcultosFiltrados);
    return valesFiltradosNoActivados;
  }

  function filtrarCuponesActivados(allVisiblesSFAct: ValesData[]) {
    const valesFiltradosActivados = getCuponesFiltrados(allVisiblesSFAct);
    const nuevosOcultosFiltrados = getCuponesFiltrados(hideLsActivados);
    const numLimiteVisiblesAct = valesVisiblesSFActivados.length;
    while (
      nuevosOcultosFiltrados.length > 0 &&
      valesFiltradosActivados.length < numLimiteVisiblesAct
    ) {
      const cuponOcultoFiltradoAvisibleFiltrado = nuevosOcultosFiltrados.shift();
      if (cuponOcultoFiltradoAvisibleFiltrado !== undefined) {
        valesFiltradosActivados.push(cuponOcultoFiltradoAvisibleFiltrado);
      }
    }
    setVoucherActWithFilterApplied(valesFiltradosActivados);
    setHideLsFiltradaActivados(nuevosOcultosFiltrados);
    return valesFiltradosActivados;
  }

  function filtrarCuponesCanjeados(allVisiblesSFCanj: ValesData[]) {
    const valesFiltradosCanjeados = getCuponesFiltrados(allVisiblesSFCanj);
    const nuevosOcultosFiltrados = getCuponesFiltrados(hideLsCanjeados);
    const numLimiteVisiblesCanj = valesVisiblesSFCanjeados.length;
    while (
      nuevosOcultosFiltrados.length > 0 &&
      valesFiltradosCanjeados.length < numLimiteVisiblesCanj
    ) {
      const cuponOcultoFiltradoAvisibleFiltrado = nuevosOcultosFiltrados.shift();
      if (cuponOcultoFiltradoAvisibleFiltrado !== undefined) {
        valesFiltradosCanjeados.push(cuponOcultoFiltradoAvisibleFiltrado);
      }
    }
    setVoucherCanjWithFilterApplied(valesFiltradosCanjeados);
    setHideLsFiltradaCanjeados(nuevosOcultosFiltrados);
    return valesFiltradosCanjeados;
  }

  function filtrarCuponesPromocion(allVisiblesSFPromo: ValesData[]) {
    const valesFiltradosPromo = getCuponesFiltrados(allVisiblesSFPromo);
    const nuevosOcultosFiltrados = getCuponesFiltrados(hideLsPreactiva2);
    const numLimiteVisiblesPromo = valesVisiblesSFPromos.length;
    while (
      nuevosOcultosFiltrados.length > 0 &&
      valesFiltradosPromo.length < numLimiteVisiblesPromo
    ) {
      const cuponOcultoFiltradoAvisibleFiltrado = nuevosOcultosFiltrados.shift();
      if (cuponOcultoFiltradoAvisibleFiltrado !== undefined) {
        valesFiltradosPromo.push(cuponOcultoFiltradoAvisibleFiltrado);
      }
    }
    setVoucherPromoWithFilterApplied(valesFiltradosPromo);
    setHideLsPreactiva2(nuevosOcultosFiltrados);
    return valesFiltradosPromo;
  }

  function actualizarValesNoActFiltrados(
    cuponesFiltrados: ValesData[],
    prevState: ValesData[],
  ) {
    // para mantener el orden del back-End -> [...isFiltered, ...prevState]
    const cuponesFiltradosVisibles = [...cuponesFiltrados, ...prevState];
    eliminarDuplicados(cuponesFiltradosVisibles);
    return filtrarCuponesNoActivados(cuponesFiltradosVisibles);
  }
  function actualizarValesActFiltrados(
    cuponesFiltrados: ValesData[],
    prevState: ValesData[],
  ) {
    // para mantener el orden del back-End -> [...isFiltered, ...prevState]
    const cuponesFiltradosVisibles = [...cuponesFiltrados, ...prevState];
    eliminarDuplicados(cuponesFiltradosVisibles);
    return filtrarCuponesActivados(cuponesFiltradosVisibles);
  }
  function actualizarValesCanjFiltrados(
    cuponesFiltrados: ValesData[],
    prevState: ValesData[],
  ) {
    // para mantener el orden del back-End -> [...isFiltered, ...prevState]
    const cuponesFiltradosVisibles = [...cuponesFiltrados, ...prevState];
    eliminarDuplicados(cuponesFiltradosVisibles);
    return filtrarCuponesCanjeados(cuponesFiltradosVisibles);
  }

  function actualizarValesPromoFiltrados(
    cuponesFiltrados: ValesData[],
    prevState: ValesData[],
  ) {
    // para mantener el orden del back-End -> [...isFiltered, ...prevState]
    const cuponesFiltradosVisibles = [...cuponesFiltrados, ...prevState];
    eliminarDuplicados(cuponesFiltradosVisibles);
    return filtrarCuponesPromocion(cuponesFiltradosVisibles);
  }

  function vaciarListas() {
    setVoucherNotActWithFilterApplied([]);
    setVoucherActWithFilterApplied([]);
    setVoucherCanjWithFilterApplied([]);
    setVoucherPromoWithFilterApplied([]);
  }

  function gestionarFiltrosActivos(prevState: string[], filter: string) {
    let newFilter: string[];
    vaciarListas();
    if (prevState.includes(filter)) {
      newFilter = prevState.filter((prevFilter) => prevFilter !== filter);
    } else {
      newFilter = [...prevState, filter];
    }
    return newFilter;
  }

  function sacar6CuponesOcultosFromLsByTipoCupon(hideLs: ValesData[]) {
    const newValesVisibles: ValesData[] = [];
    const limiteCuponesVerMas = FiltersConstants.NUM_CUPONES_BTN_VER_MAS;
    let z = 0;
    while (hideLs.length > 0 && z < limiteCuponesVerMas) {
      const vale = hideLs.shift();
      if (vale !== undefined) {
        newValesVisibles.push(vale);
        const cuponHtml = document.querySelector(`[data-id='${vale.valeEAN}']`);
        cuponHtml?.classList.remove(FiltersConstants.SELECTOR_CUPONES_VISIBLES);
        cuponHtml?.classList.remove(FiltersConstants.SELECTOR_CUPONES_OCULTOS);
        cuponHtml?.classList.add(FiltersConstants.SELECTOR_CUPONES_VISIBLES);
      }
      z += 1;
    }
    return newValesVisibles;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function verMasPreactivados() {
    const newValesVisiblesSFPreactivados = sacar6CuponesOcultosFromLsByTipoCupon(
      hideLsPreactiva2,
    );
    setValesVisiblesSFPromos([
      ...valesVisiblesSFPromos,
      ...newValesVisiblesSFPreactivados,
    ]);
    const valesFiltradosPreactivados = getCuponesFiltrados(
      valesVisiblesSFPromos,
    );
    setVoucherPromoWithFilterApplied(valesFiltradosPreactivados);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function forzarActualizacionValesVisiblesSFByLs(
    newVisiblesSinFiltrar: ValesData[],
    valesVisiblesSinFiltrar: ValesData[],
  ) {
    // eslint-disable-next-line no-param-reassign
    valesVisiblesSinFiltrar.length = 0;
    valesVisiblesSinFiltrar.push(...newVisiblesSinFiltrar);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function verMasNoActivados() {
    const newValesVisiblesSFNoActivados = sacar6CuponesOcultosFromLsByTipoCupon(
      hideLsNoActivados,
    );
    const allVisiblesSFNoAct: ValesData[] = [
      ...valesVisiblesSFNoActivados,
      ...newValesVisiblesSFNoActivados,
    ];
    setValesVisiblesSFNoActivados(allVisiblesSFNoAct);
    forzarActualizacionValesVisiblesSFByLs(
      allVisiblesSFNoAct,
      valesVisiblesSFNoActivados,
    );
    // valesVisiblesSFNoActivados.length = 0;
    // valesVisiblesSFNoActivados.push(...allVisiblesSFNoAct);
    filtrarCuponesNoActivados(allVisiblesSFNoAct);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function verMasActivados() {
    const newValesVisiblesSFActivados = sacar6CuponesOcultosFromLsByTipoCupon(
      hideLsActivados,
    );
    const allVisiblesSFAct = [
      ...valesVisiblesSFActivados,
      ...newValesVisiblesSFActivados,
    ];
    setValesVisiblesSFActivados(allVisiblesSFAct);
    forzarActualizacionValesVisiblesSFByLs(
      allVisiblesSFAct,
      valesVisiblesSFActivados,
    );
    // valesVisiblesSFActivados.length = 0;
    // valesVisiblesSFActivados.push(...allVisiblesSFNoAct);
    filtrarCuponesActivados(allVisiblesSFAct);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function verMasCanjeados() {
    const newValesVisiblesSFCanjeados = sacar6CuponesOcultosFromLsByTipoCupon(
      hideLsCanjeados,
    );
    const allVisiblesSFCanj = [
      ...valesVisiblesSFCanjeados,
      ...newValesVisiblesSFCanjeados,
    ];
    setValesVisiblesSFCanjeados(allVisiblesSFCanj);
    forzarActualizacionValesVisiblesSFByLs(
      allVisiblesSFCanj,
      valesVisiblesSFCanjeados,
    );
    // valesVisiblesSFCanjeados.length = 0;
    // valesVisiblesSFCanjeados.push(...allVisiblesSFNoAct);
    filtrarCuponesCanjeados(allVisiblesSFCanj);
  }

  useEffect(() => {
    if (showMoreNoAct) {
      verMasNoActivados();
      setShowMoreNoAct(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMoreNoAct]);

  useEffect(() => {
    if (showMoreAct) {
      verMasActivados();
      setShowMoreAct(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMoreAct]);

  useEffect(() => {
    if (showMoreCanj) {
      verMasCanjeados();
      setShowMoreCanj(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMoreCanj]);

  useEffect(() => {
    if (activeFilters.length > 0 || filtrosOtrosActivos.length > 0) {
      // NO-Activados
      filtrarCuponesNoActivados(valesVisiblesSFNoActivados);
      // Activados
      filtrarCuponesActivados(valesVisiblesSFActivados);
      // Canjeados
      filtrarCuponesCanjeados(valesVisiblesSFCanjeados);
      // Promociones
      filtrarCuponesPromocion(valesVisiblesSFPromos);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilters, filtrosOtrosActivos]);

  const value: ValeContextType = {
    isOpenFilter,
    hideLsNoActivados,
    hideLsFiltradaNoActivados,
    hideLsPreactiva2,
    hideLsActivados,
    hideLsFiltradaActivados,
    hideLsCanjeados,
    hideLsFiltradaCanjeados,
    filtrosOtros,
    filtrosOtrosAMostrar,
    isFiltroSoportePostalVisible,
    filtrosProductos,
    activeFilters,
    filtrosOtrosActivos,
    voucherNotActWithFilterApplied,
    voucherActWithFilterApplied,
    voucherCanjWithFilterApplied,
    voucherPromoWithFilterApplied,
    valesVisiblesSFNoActivados,
    valesVisiblesSFActivados,
    valesVisiblesSFCanjeados,
    valesVisiblesSFPromos,
    showMoreNoAct,
    showMoreAct,
    showMoreCanj,
    changeShowMoreNoAct: (state: boolean) => {
      setShowMoreNoAct(state);
    },
    changeShowMoreAct: (state: boolean) => {
      setShowMoreAct(state);
    },
    changeShowMoreCanj: (state: boolean) => {
      setShowMoreCanj(state);
    },
    loadHideLsNoActivados: (vales: ValesData[]) => {
      setHideLsNoActivados(vales);
    },
    loadHideLsFiltradaNoActivados: (vales: ValesData[]) => {
      setHideLsFiltradaNoActivados(vales);
    },
    loadHideLsPreactiva2: (vales: ValesData[]) => {
      setHideLsPreactiva2(vales);
    },
    loadHideLsActivados: (vales: ValesData[]) => {
      setHideLsActivados(vales);
    },
    loadHideLsCanjeados: (vales: ValesData[]) => {
      setHideLsCanjeados(vales);
    },
    changeHideLsNoActivados: () => {
      // setHideLsNoActivados();
    },
    changeOpenFilter: () => {
      setIsOpenFilter((prevState) => !prevState);
    },
    loadFilterProducs: (filtros) => {
      setFiltrosProductos(filtros);
    },
    loadFilterOtros: (filtros) => {
      setFiltrosOtros(filtros);
    },
    loadIsFiltrosSoportePostalVisible: (isVisible) => {
      setIsFiltroSoportePostalVisible(isVisible);
    },
    loadFiltrosOtrosAMostrar: (filtros) => {
      setFiltrosOtrosAMostrar(filtros);
    },
    existenFiltrosvisibles: () => {
      return filtrosProductos.length > 0 || filtrosOtrosAMostrar.length > 0;
    },
    addFilter: (filter: string) => {
      setActiveFilters((prevState) => {
        return gestionarFiltrosActivos(prevState, filter);
      });
    },
    addFilterURL: (filter: string) => {
      setFiltrosOtrosActivos((prevState) => {
        return gestionarFiltrosActivos(prevState, filter);
      });
    },
    loadFilters: (newFilters: string[]) => {
      setActiveFilters(newFilters);
    },
    loadFiltersOtros: (newFilters: string[]) => {
      setFiltrosOtrosActivos(newFilters);
    },
    loadValesVisiblesNoFiltrados: (
      valesVisiblesNoActivados: ValesData[],
      valesVisiblesActivados: ValesData[],
      valesVisiblesCanjeados: ValesData[],
      valesVisiblesPromos: ValesData[],
    ) => {
      setValesVisiblesSFNoActivados(valesVisiblesNoActivados);
      setValesVisiblesSFActivados(valesVisiblesActivados);
      setValesVisiblesSFCanjeados(valesVisiblesCanjeados);
      setValesVisiblesSFPromos(valesVisiblesPromos);
    },
    filtrarTodosLosCupones: (
      visiblesAFiltrarNoActivados,
      visiblesAFiltrarActivados,
      visiblesAFiltrarCanjeados,
      visiblesAFiltrarPromos,
    ) => {
      const filtra2NoAct = getCuponesFiltrados(visiblesAFiltrarNoActivados);
      setVoucherNotActWithFilterApplied((prevState) => {
        return actualizarValesNoActFiltrados(filtra2NoAct, prevState);
      });
      const filtra2Act = getCuponesFiltrados(visiblesAFiltrarActivados);
      setVoucherActWithFilterApplied((prevState) => {
        return actualizarValesActFiltrados(filtra2Act, prevState);
      });
      const filtra2Canj = getCuponesFiltrados(visiblesAFiltrarCanjeados);
      setVoucherCanjWithFilterApplied((prevState) => {
        return actualizarValesCanjFiltrados(filtra2Canj, prevState);
      });
      const filtra2Promos = getCuponesFiltrados(visiblesAFiltrarPromos);
      setVoucherPromoWithFilterApplied((prevState) => {
        return actualizarValesPromoFiltrados(filtra2Promos, prevState);
      });
    },
  };
  return <ValeContext.Provider value={value}>{children}</ValeContext.Provider>;
};

export const useValeContext = () => {
  const context = useContext(ValeContext);
  if (context === undefined)
    throw new Error('ValeContext must be used within a ValeProvider');
  return context;
};
